import { useSyncExternalStore } from 'react';

/** PanelContents の pc ブレークポイント（幅 >= 1024）に一致 */
const DESK_PC_MIN_WIDTH_MEDIA = '(min-width: 1024px)';

export function useDeskPcViewport(): boolean {
    return useSyncExternalStore(
        (onStoreChange) => {
            if (typeof window === 'undefined') return () => {};
            const mq = window.matchMedia(DESK_PC_MIN_WIDTH_MEDIA);
            mq.addEventListener('change', onStoreChange);
            return () => mq.removeEventListener('change', onStoreChange);
        },
        () =>
            typeof window !== 'undefined' ? window.matchMedia(DESK_PC_MIN_WIDTH_MEDIA).matches : false,
        () => true,
    );
}
